import { ItemRewardType } from '@/cowboy/EnumTypes'
import {
  DIRECT_PAYMENTS_ACH_ROUTE,
  DIRECT_PAYMENTS_DEBIT_CARD_ROUTE
} from '@/router/routes/route-names'

export const directPaymentType = Object.freeze({
  ACH: 'ACH',
  DEBIT: 'DEBIT'

  // Unhandled funding types available via Ingo
  // CREDIT: 'CREDIT',
  // BILLPAY: 'BILLPAY'
})

export const getDirectPaymentRouteForDirectPaymentType = type => {
  switch (type) {
    case directPaymentType.ACH:
      return DIRECT_PAYMENTS_ACH_ROUTE
    case directPaymentType.DEBIT:
      return DIRECT_PAYMENTS_DEBIT_CARD_ROUTE
    default:
      return null
  }
}

export const getDirectPaymentTypeFromItemType = type => {
  switch (type) {
    case ItemRewardType.PAYMENT_ACH:
      return directPaymentType.ACH
    case ItemRewardType.PAYMENT_DEBIT_CARD:
      return directPaymentType.DEBIT
    default:
      return null
  }
}

export const INGO_PAY_CLIENT_SCRIPT_ID = 'ingo-pay-iframe-sdk'
export const INGO_PAY_CLIENT_SCRIPT_URL =
  '/ingo.instant.payments.sdk-2.1.0.min.js'
